var _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatisticMailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 51,
    height: 51,
    rx: 25.5,
    fill: "#F5F6F8",
    stroke: "#E4E5E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0663 17C16.4522 17 14.333 19.1192 14.333 21.7333V30.2667C14.333 32.8808 16.4522 35 19.0663 35H32.933C35.5472 35 37.6663 32.8808 37.6663 30.2667V21.7333C37.6663 19.1192 35.5472 17 32.933 17H19.0663ZM21.1163 22.7333C20.785 22.4848 20.3149 22.552 20.0663 22.8833C19.8178 23.2147 19.885 23.6848 20.2163 23.9333L24.9497 27.4833C25.5719 27.95 26.4275 27.95 27.0497 27.4833L31.783 23.9333C32.1144 23.6848 32.1815 23.2147 31.933 22.8833C31.6845 22.552 31.2144 22.4848 30.883 22.7333L26.1497 26.2833C26.0608 26.35 25.9386 26.35 25.8497 26.2833L21.1163 22.7333Z",
    fill: "#898D9A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6663 22L11.333 22",
    stroke: "#898D9A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6663 30L11.333 30",
    stroke: "#898D9A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6662 26H9.99951",
    stroke: "#898D9A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatisticMailIcon);
export default __webpack_public_path__ + "static/media/statistic-mail-icon.a883f51a8bb45a7b6e934fb70830018a.svg";
export { ForwardRef as ReactComponent };